import {faCircleCheck, faCircleXmark, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useRef, useState, } from 'react'
import domain from '../../../reusecomponent/domain';
import { ErrorToastContainer, SuccessToastContainer } from '../../function/CustomFunction';
import { MultiSelect } from 'react-multi-select-component';
import './style.css'
import { useSelector } from 'react-redux';

function Biling({ componentvisible,payNow,bilininformation,setBilininformation1,setPreloader,product }) {

  const gmlistRef = useRef([]);
  const [selected, setSelected] = useState([]);
  const Accesstoken = useSelector((state) => (state.Token.value));
  const ReferNot = useRef(null);

  useEffect(() => {
    if(product === 'gmb'){
      const storeCodes = selected.map(item => item.value);
      setBilininformation1((prevValues) => ({
        ...prevValues,
        store_code: storeCodes,
      }));
    }
  }, [selected]);

  useEffect(()=>{
    if(product === 'gmb'){
      Gmblist();
    }
  },[]);

  let Gmblist = async () => {
      try {
        setPreloader(true);
        const access_token = Accesstoken;
        const myHeaders = new Headers();
        myHeaders.append('Authorization', `Bearer ${access_token}`);

        const requestOptions = {
          method: 'GET',
          headers: myHeaders,
        };

        const response = await fetch(`${domain()}/gmb/gmb/list`, requestOptions);
        const result = await response.json();
        
        if (response.ok) {
          gmlistRef.current = result.data;
        } else {
          ErrorToastContainer(result.message);
        }
      } catch (error) {
           ErrorToastContainer("Internal Server Problem");
      } finally {
        setPreloader(false);
      }
  }
  
  useEffect(() => {
    if (bilininformation.gstnumber.length === 15) {
      setPreloader(true);
      const myHeaders = new Headers();
      const access_token = Accesstoken;
      myHeaders.append('Authorization', `Bearer ${access_token}`);
      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
      };
      fetch(`${domain()}/gst-verifaction/${btoa(bilininformation.gstnumber)}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setPreloader(false);
          if(result.status){
            setBilininformation1((prevValues) => ({
              ...prevValues,
              validated: true,
            }));
             SuccessToastContainer(result.message);
          }else{
            setBilininformation1((prevValues) => ({
              ...prevValues,
              validated: false,
            }));
            ErrorToastContainer(result.message);
          }
        })
        .catch(() => {
          setPreloader(false);
          setBilininformation1((prevValues) => ({
              ...prevValues,
              validated: false,
            }));
          ErrorToastContainer('Internal Server Error');
        });
    }
  }, [bilininformation.gstnumber]);

  let ReferCodeValidate = async (e) => {
    if(e.target.value.length === 10){
      ReferNot.current = null;
        try{
            setPreloader(true);
            const myHeaders = new Headers();
            myHeaders.append('Authorization', `Bearer ${Accesstoken}`);
            const requestOptions = {
              method: 'GET',
              headers: myHeaders,
              redirect: 'follow',
            };
            const response = await fetch(`${domain()}/gmb/referral_code/validate/${btoa(e.target.value)}`, requestOptions)
            const result = await response.json();
            if(response.ok){
                 setBilininformation1(prev => ({
                  ...prev,
                  referel_code: e.target.value,
                  referel_code_validate: true,
                }));

                const nDay = JSON.parse(result.data.refer_fetures);
                if(nDay.referral_extended_date != undefined){
                    ReferNot.current = `Congrats! Your referral unlocked ${nDay.referral_extended_date} extra days of service.`;
                }

              SuccessToastContainer(result.message);
            }else{
              setBilininformation1(prev => ({
                ...prev,
                referel_code: e.target.value,
                referel_code_validate: false,
              }));
              ErrorToastContainer(result.message);
            }
        }catch(e){
          ErrorToastContainer("Internal Server Problem");
        }finally{
          console.log(bilininformation.referel_code_validate);
          setPreloader(false);
        }
    }else if(bilininformation.referel_code_validate != null){
      ReferNot.current = null;
      setBilininformation1(prev => ({
        ...prev,
        referel_code: '',
        referel_code_validate: null,
      }));
    }
  }

  return (
    <div className='blur-background d-flex justify-content-center align-items-center' style={{ position: 'fixed', top: '0', left: '0', height: '100vh', width: '100vw', zIndex: '1050', background: 'rgba(0,0,0,0.18)', }}>      <div className="card shadow-lg border-0 p-0" style={{ width: '420px', maxWidth: '95vw', borderRadius: 18, boxShadow: '0 8px 32px 0 rgba(7,94,84,0.18)', maxHeight: '90vh', overflowY: 'auto' }}>
        <form className="forms-sample row p-4 w-100 m-0" onSubmit={(e) => e.preventDefault()} style={{ overflowY: 'auto', maxHeight: '80vh', minHeight: 300, marginRight: '0', width: '100%', boxSizing: 'border-box' }}>
          <button type="button" aria-label="Close" className='btn btn-light position-absolute' style={{ top: 18, right: 18, borderRadius: '50%', width: 32, height: 32, padding: 0, fontSize: 18, boxShadow: '0 1px 4px rgba(0,0,0,0.08)',display: 'flex',justifyContent: 'center',alignContent: 'center' }} onClick={() => {
              componentvisible(false);
              setBilininformation1({
                plan_id: null,
                havegst: '',
                gstnumber: '',
                validated: null,
                store_code: null,
                amount: 0
              });
          }}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
          <h4 tabIndex={-1} className='text-center fw-bold mb-3 w-100' style={{ outline: 'none', fontSize: '1.35rem', letterSpacing: 0.5, color: 'var(--companycolor)' }}>Enter Billing Information</h4>
           
          {product === "gmb" && (
            <>
              <div className="my-2 multi-select-wrapper">
                <label className="fw-semibold mb-1">
                  Please Select Gmb Account
                </label>

                <MultiSelect
                  options={gmlistRef.current}
                  value={selected}
                  onChange={setSelected}
                  labelledBy="Select"
                  hasSelectAll={true}
                  closeOnChangedValue={false}
                />

                {selected.length === 0 && (
                  <div
                    className="invalid-feedback d-block p-0 m-0"
                    style={{ fontSize: "0.9rem" }}
                  >
                    Select now
                  </div>
                )}
              </div>

              <div className="my-2 multi-select-wrapper">
                <label htmlFor="referel_code" className="fw-semibold">Refer Code (Optional)</label>
                  <div className="position-relative">
                    <input
                      id="referel_code"
                      type="text"
                      className="form-control rounded"
                      placeholder="Enter Refer Code (Optional)"
                      name="referel_code"
                      style={{ height: 44, minHeight: 44, border: '1px solid #d1d5db', background: '#f8fafc', paddingRight: '2.5rem', width: '100%', boxSizing: 'border-box' }}
                      maxLength={10}
                      onChange={ReferCodeValidate}
                    />
                    {bilininformation.referel_code.length === 10 ? (
                      <span
                        className="position-absolute top-50 translate-middle-y"
                        style={{ right: 10 }}
                        aria-hidden="true"
                      >
                        <span className="d-inline-flex align-items-center justify-content-center rounded-circle" style={{ width: 28, height: 28, background: 'rgba(7,94,84,0.08)' }}>
                          {bilininformation.referel_code_validate === true && (<FontAwesomeIcon style={{ color: 'var(--companycolor)', fontSize: 16 }} icon={faCircleCheck} />)}
                          {bilininformation.referel_code_validate === false && (<FontAwesomeIcon style={{ color: 'red', fontSize: 16 }} icon={faCircleXmark} />)}
                        </span>
                      </span>
                    ) : null}
                  </div>
              </div>
            </>
          )}

          <div className="form-group my-2">
            <label htmlFor="exampleFormControlSelect2" className="fw-semibold">Do you have GST?</label>
            <select className="form-control py-2 rounded" id="exampleFormControlSelect2" name='havegst' onChange={(e) => {
                setBilininformation1(prev => ({
                  ...prev,
                  havegst: e.target.value,
                }));
              }
            } style={{ cursor: 'pointer', border: '1px solid #d1d5db', background: '#f8fafc', height: '44px', minHeight: '44px', width: '100%', boxSizing: 'border-box' }} >
              <option value=''>Select</option>
              <option value='Yes'>Yes</option>
              <option value='No'>No</option>
            </select>
            <div className="invalid-feedback d-block p-0 m-0" style={{ fontSize: '0.95rem' }}>{bilininformation.havegst === '' ? 'Select now' : ''}</div>
          </div>
          
          {bilininformation.havegst === 'Yes' ? (
            <div className="form-group">
              <label htmlFor="gstnumber" className="fw-semibold">GST Number</label>
              <div className="position-relative">
                <input
                  id="gstnumber"
                  type="text"
                  className="form-control rounded"
                  placeholder="Enter GST number"
                  name="gstnumber"
                  style={{ height: 44, minHeight: 44, border: '1px solid #d1d5db', background: '#f8fafc', paddingRight: '2.5rem', width: '100%', boxSizing: 'border-box' }}
                  maxLength={15}
                  onChange={(e) => {          
                      setBilininformation1(prev => ({
                        ...prev,
                        gstnumber: e.target.value,
                      }));
                    }
                  }
                />
                {bilininformation.gstnumber.length === 15 ? (
                  <span
                    className="position-absolute top-50 translate-middle-y"
                    style={{ right: 10 }}
                    aria-hidden="true"
                  >
                    <span className="d-inline-flex align-items-center justify-content-center rounded-circle" style={{ width: 28, height: 28, background: 'rgba(7,94,84,0.08)' }}>
                      {bilininformation.validated === true && (<FontAwesomeIcon style={{ color: 'var(--companycolor)', fontSize: 16 }} icon={faCircleCheck} />)}
                      {bilininformation.validated === false && (<FontAwesomeIcon style={{ color: 'red', fontSize: 16 }} icon={faCircleXmark} />)}
                    </span>
                  </span>
                ) : null}
              </div>
              <div className="invalid-feedback d-block p-0 m-0" style={{ fontSize: '0.95rem' }}>
                {bilininformation.gstnumber === '' ? 'Enter GST Number' : bilininformation.gstnumber.length !== 15 ? 'Enter Valid GST Number' : ''}
              </div>
            </div>
          ) : null}

          <div>
            <div className='d-flex justify-content-between'>
              <p>Amount: </p>
              <p>INR {bilininformation.amount}.00 * {product === "gmb" ? selected.length : '1'}</p>
            </div>
            <div className='d-flex justify-content-between'>
              <p>Tax: </p>
              <p>{((selected.length > 0 ? bilininformation.amount * selected.length : bilininformation.amount * 1) * 18) / 100}</p>
            </div>
            <div className='d-flex justify-content-between'>
              <p>Total Amount: </p>
              {selected.length > 0 && (
                <p>{(bilininformation.amount * selected.length)+(((bilininformation.amount * selected.length ?? 1) * 18) / 100)}</p>
              )}
              {selected.length === 0 && (
                <p>{bilininformation.amount+((bilininformation.amount * 18) / 100)}</p>
              )}
            </div>
            {ReferNot.current != null && (
              <div className='d-flex justify-content-between text-danger'>
                <p>{ReferNot.current}</p>
              </div>
            )}
          </div>

          <div className="form-group mt-4 mb-0 w-100 ">
            <button type="submit" className="btn w-100 fw-bold text-center" style={{ padding: '10px', background: 'var(--companycolor)', color: '#fff', borderRadius: 8, fontSize: '1.08rem', letterSpacing: 0.5, boxShadow: '0 2px 8px rgba(7,94,84,0.18)',textAlign: 'center' }} onClick={() => {
              if(product === 'gmb' && selected.length === 0){
                return;
              }else if(bilininformation.havegst === ''){
                return;
              }else if(bilininformation.havegst === 'Yes' && bilininformation.gstnumber.length !== 15){
                return;
              }
  
              payNow();
            }}>Pay Now</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Biling
